<template>
  <div class="my-3 py-2 container-fluid">
    <button
      v-if="lastSeason"
      @click="showCreateForm"
      class="mb-3 btn btn-sm btn-outline-success"
    >
      {{ $t("teachers.createTeacher") }}
    </button>

    <div class="row">
      <transition name="slide-fade" class="my-4">
        <form-create-teacher
          v-if="isCreateTeacherVisible"
          @close="hideCreateForm"
          @formSubmitted="teacherCreated"
        />
      </transition>
      <div class="col-12">
        <teacher-list
          :teachers="teachers"
          :lastSeason="lastSeason"
          :isEditFormVisible="isEditFormVisible"
          @hide-create-form="hideChild"
          @get-teachers="fetchTeachers"
          @close-edit-teacher="fetchTeachers"
          @hide-pagination="hidePagination"
          @show-pagination="showPagination"
        />
      </div>
    </div>
    <span v-if="isPaginationVisible">
      <soft-pagination color="success" size="sm">
        <soft-pagination-item
          prev
          @click="prevPage"
          :disabled="currentPage === 1"
        />
        <div v-for="item in totalPages" :key="item">
          <soft-pagination-item
            v-if="item == currentPage"
            :label="currentPage"
            active
          />
          <soft-pagination-item
            v-if="item != currentPage"
            :label="item"
            @click="currPage(item)"
          />
        </div>
        <soft-pagination-item
          next
          @click="nextPage"
          :disabled="currentPage === totalPages"
        /> </soft-pagination
    ></span>
  </div>
</template>

<script>
import axios from "axios";
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import TeacherList from "./components/TeacherList";
import FormCreateTeacher from "@/components/FormCreateTeacher";

export default {
  name: "teachers",
  components: {
    TeacherList,
    SoftPagination,
    SoftPaginationItem,
    FormCreateTeacher,
  },
  data() {
    return {
      teachers: [],
      currentPage: 1,
      totalPages: 1,
      isPaginationVisible: true,
      isCreateTeacherVisible: false,
      isEditFormVisible: false,
      lastSeason: false,
    };
  },
  created() {
    this.fetchTeachers();
  },
  methods: {
    async fetchTeachers(page = 1) {
      let response = await axios.get(`teachers?page=${page}`);
      this.teachers = response.data.teachers;
      this.currentPage = response.data.meta.current_page;
      this.totalPages = response.data.meta.last_page;
      this.lastSeason = response.data.last_season;
    },
    showCreateForm() {
      this.isCreateTeacherVisible = true;
      this.isEditFormVisible = false;
    },
    hideChild() {
      this.isCreateTeacherVisible = false;
      this.isEditFormVisible = true;
    },
    teacherCreated() {
      this.isCreateTeacherVisible = false;
      this.fetchTeachers();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchTeachers(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchTeachers(this.currentPage);
      }
    },
    currPage(item) {
      this.currentPage = item;
      this.fetchTeachers(item);
    },
    hidePagination() {
      this.isPaginationVisible = false;
    },
    showPagination() {
      this.isPaginationVisible = true;
    },
    hideCreateForm() {
      this.isCreateTeacherVisible = false;
      this.isEditFormVisible = false;
    },
  },
};
</script>
